import React from 'react';
import { FiEdit } from 'react-icons/fi';
import ActionButton from './ActionButton';

const EditButton = ({ onClick, title = "Edit", className = "" }) => {
  return (
    <ActionButton
      icon={FiEdit}
      onClick={onClick}
      title={title}
      className={className}
    />
  );
};

export default EditButton;
